
interface SystemAlertsProps {
  systemData: any;
}

export function SystemAlerts({ systemData }: SystemAlertsProps) {
  if (!systemData) return null;

  const alerts = [];
  const { powerFlow, inverter } = systemData;

  // Verificar alertas del sistema
  if (inverter?.Temperature > 50) {
    alerts.push({
      type: 'warning',
      icon: 'ri-temp-hot-line',
      title: 'Temperatura Alta',
      message: `Inversor a ${inverter.Temperature}°C - Revisar ventilación`,
      color: 'orange'
    });
  }

  if (inverter?.DeviceStatus?.ErrorCode > 0) {
    alerts.push({
      type: 'error',
      icon: 'ri-error-warning-line',
      title: 'Error del Inversor',
      message: `Código de error: ${inverter.DeviceStatus.ErrorCode}`,
      color: 'red'
    });
  }

  if (powerFlow?.Battery?.SOC < 20) {
    alerts.push({
      type: 'warning',
      icon: 'ri-battery-low-line',
      title: 'Batería Baja',
      message: `Nivel de carga: ${powerFlow.Battery.SOC}%`,
      color: 'yellow'
    });
  }

  if (powerFlow?.P_Grid > 2000) {
    alerts.push({
      type: 'info',
      icon: 'ri-arrow-down-line',
      title: 'Alto Consumo de Red',
      message: `Importando ${powerFlow.P_Grid}W de la red`,
      color: 'blue'
    });
  }

  if (powerFlow?.P_Grid < -3000) {
    alerts.push({
      type: 'success',
      icon: 'ri-arrow-up-line',
      title: 'Alta Exportación',
      message: `Vendiendo ${Math.abs(powerFlow.P_Grid)}W a la red`,
      color: 'green'
    });
  }

  // Si no hay alertas, mostrar estado normal
  if (alerts.length === 0) {
    alerts.push({
      type: 'success',
      icon: 'ri-check-line',
      title: 'Sistema Operativo',
      message: 'Todos los parámetros dentro de rangos normales',
      color: 'green'
    });
  }

  const getAlertStyles = (color: string) => {
    const styles = {
      red: {
        bg: 'bg-red-50 border-red-200',
        icon: 'bg-red-500 text-white',
        text: 'text-red-800',
        subtext: 'text-red-600'
      },
      orange: {
        bg: 'bg-orange-50 border-orange-200',
        icon: 'bg-orange-500 text-white',
        text: 'text-orange-800',
        subtext: 'text-orange-600'
      },
      yellow: {
        bg: 'bg-yellow-50 border-yellow-200',
        icon: 'bg-yellow-500 text-white',
        text: 'text-yellow-800',
        subtext: 'text-yellow-600'
      },
      blue: {
        bg: 'bg-blue-50 border-blue-200',
        icon: 'bg-blue-500 text-white',
        text: 'text-blue-800',
        subtext: 'text-blue-600'
      },
      green: {
        bg: 'bg-green-50 border-green-200',
        icon: 'bg-green-500 text-white',
        text: 'text-green-800',
        subtext: 'text-green-600'
      }
    };
    return styles[color as keyof typeof styles] || styles.blue;
  };

  return (
    <div className="space-y-3">
      <h2 className="text-lg font-semibold text-gray-900 flex items-center">
        <i className="ri-notification-3-line text-cyan-600 w-5 h-5 flex items-center justify-center text-xl mr-2"></i>
        Alertas y Avisos del Sistema
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {alerts.map((alert, index) => {
          const styles = getAlertStyles(alert.color);
          
          return (
            <div
              key={index}
              className={`${styles.bg} border rounded-lg p-4 transition-all duration-200 hover:shadow-md`}
            >
              <div className="flex items-start space-x-3">
                <div className={`${styles.icon} w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0`}>
                  <i className={`${alert.icon} w-5 h-5 flex items-center justify-center text-xl`}></i>
                </div>
                
                <div className="flex-1 min-w-0">
                  <h3 className={`font-semibold text-sm ${styles.text} mb-1`}>
                    {alert.title}
                  </h3>
                  <p className={`text-sm ${styles.subtext}`}>
                    {alert.message}
                  </p>
                  
                  <div className="flex items-center mt-2 space-x-2">
                    <div className={`w-2 h-2 rounded-full ${styles.icon.split(' ')[0]} animate-pulse`}></div>
                    <span className={`text-xs ${styles.subtext} font-medium`}>
                      {new Date().toLocaleTimeString()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
